import { Component, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-week-to-date-dt',
  templateUrl: './week-to-date-dt.component.html',
  styleUrls: ['./week-to-date-dt.component.scss', '../../../dashboard.scss'],
  standalone: false
})
export class WeekToDateDtComponent {
  @Input() dashboardData: any;
  totalSalesWeek: any;
  totalOrdersItemsWeek: string = '';
  salesValuePerItemWeek: string = '0';
  averageOrderValueWeek: string = '0';
  sushiSalesWeek: any = 0;
  sushiItemsSoldWeek: any = 0;
  bentoSalesWeek: any = 0;
  bentoItemsSoldWeek: any = 0;
  commonSalesWeek: any = 0;
  commonItemsSoldWeek: any = 0;
  ngOnChanges(changes: SimpleChanges) {
    if (changes['dashboardData']) {
      // -------Week To Date Section-------
      const dashBoardData = this.dashboardData?.dt_dashboard_data;
      this.totalSalesWeek = this.setDecimalPoints(this.fnCheckNull(dashBoardData?.this_week_sales));

      // TOTAL ORDERS / ITEMS
      let thisWeekItemsSold = this.fnCheckNull(dashBoardData?.this_week_items_sold);
      thisWeekItemsSold = this.setDecimalPoints(thisWeekItemsSold, 0);

      let thisWeekNoOfCustOrders = this.fnCheckNull(dashBoardData?.this_week_no_of_cust_orders);
      thisWeekNoOfCustOrders = this.setDecimalPoints(thisWeekNoOfCustOrders, 0);

      this.totalOrdersItemsWeek = `${this.formatNumber(thisWeekNoOfCustOrders)} / ${this.formatNumber(thisWeekItemsSold)}`;

      // SALES VALUE / ITEM
      if (thisWeekItemsSold > 0) {
        let weeklySalesValueByItem = this.totalSalesWeek / thisWeekItemsSold;
        weeklySalesValueByItem = this.setDecimalPoints(weeklySalesValueByItem, 2);
        this.salesValuePerItemWeek = weeklySalesValueByItem.toFixed(2);
      } else {
        this.salesValuePerItemWeek = '0';
      }

      // AVERAGE ORDER $
      if (thisWeekNoOfCustOrders > 0) {
        let thisWeekAverageOrder = this.totalSalesWeek / thisWeekNoOfCustOrders;
        thisWeekAverageOrder = this.setDecimalPoints(thisWeekAverageOrder, 2);
        this.averageOrderValueWeek = thisWeekAverageOrder.toFixed(2);
      } else {
        this.averageOrderValueWeek = '0';
      }

      // SUSHI SALES
      let thisWeekSushiSales = this.fnCheckNull(dashBoardData?.this_week_dt_sushi_sales);
      thisWeekSushiSales = this.setDecimalPoints(thisWeekSushiSales);
      this.sushiSalesWeek = thisWeekSushiSales;

      // SUSHI ITEM SOLD
      let thisWeekSushiItemsSold = this.fnCheckNull(dashBoardData?.this_week_dt_sushi_items_sold);
      thisWeekSushiItemsSold = this.setDecimalPoints(thisWeekSushiItemsSold, 0);
      this.sushiItemsSoldWeek = thisWeekSushiItemsSold;

      // BENTO SALES
      let thisWeekBentoSales = this.fnCheckNull(dashBoardData?.this_week_dt_bento_sales);
      thisWeekBentoSales = this.setDecimalPoints(thisWeekBentoSales);
      this.bentoSalesWeek = thisWeekBentoSales;

      // BENTO ITEM SOLD
      let thisWeekBentoItemsSold = this.fnCheckNull(dashBoardData?.this_week_dt_bento_items_sold);
      thisWeekBentoItemsSold = this.setDecimalPoints(thisWeekBentoItemsSold, 0);
      this.bentoItemsSoldWeek = thisWeekBentoItemsSold;

      // COMMON SALES
      let thisWeekCommonSales = this.fnCheckNull(dashBoardData?.this_week_dt_common_sales);
      thisWeekCommonSales = this.setDecimalPoints(thisWeekCommonSales);
      this.commonSalesWeek = thisWeekCommonSales;

      // COMMON ITEM SOLD
      let thisWeekCommonItemsSold = this.fnCheckNull(dashBoardData?.this_week_dt_common_items_sold);
      thisWeekCommonItemsSold = this.setDecimalPoints(thisWeekCommonItemsSold, 0);
      this.commonItemsSoldWeek = thisWeekCommonItemsSold;
    }
  }
  ngOnInit() { }

  setDecimalPoints(value: number, decimal: number = 1): number {
    return Number(Number(value).toFixed(decimal));
  }
  
  fnCheckNull(a: any): number {
    return a == null ? 0 : a;
  }

  formatNumber(value: number): string {
    return value.toLocaleString('en-US', { maximumFractionDigits: 0 });
  }
}
